import { useTranslations } from 'next-intl'

import { useFormatCurrency } from '@/shared/lib'
import { Separator, ContentBox, Description } from '@/shared/ui'

import { ShowRefundAccountButton } from '../refund-account-popup/show-dialog-button'
import { ShowRefundCardButton } from '../refund-card-popup/show-dialog-button'

export type Props = {
  finalPayFee: number
  cancelFeePercent: number
  cancelFee: number
  finalContractFee: number
  refundAmount: number
  contractStatusDescription: string
  isRefundAccountButtonVisible: boolean
  isRefundCardButtonVisible: boolean
  isOldRefundTerms: boolean
}

export const RefundInformationDetail = ({
  finalPayFee,
  cancelFeePercent,
  cancelFee,
  finalContractFee,
  refundAmount,
  contractStatusDescription,
  isRefundAccountButtonVisible,
  isRefundCardButtonVisible,
  isOldRefundTerms,
}: Props) => {
  const t = useTranslations()

  const { formatCurrency } = useFormatCurrency()

  return (
    <div className="space-y-3">
      <Description.List>
        <Description.Item className="justify-between">
          <Description.ItemLabel semiBold className="text-black">
            {t('common.total_payment')}
          </Description.ItemLabel>
          <Description.ItemValue bold className="typo-headline3">
            {formatCurrency(finalPayFee)}
          </Description.ItemValue>
        </Description.Item>

        <Description.Item
          className="justify-between"
          label={t('cancel_payment.penalty_fee.label', {
            cancelFeePercent,
            showPenaltyFee: 'true',
          })}
          value={formatCurrency(cancelFee, { negative: true })}
        />

        <Description.Item
          className="justify-between"
          label={t('cancel_payment.cancel_fee', {
            cancelFeePercent,
            showCancelFee: isOldRefundTerms ? 'false' : 'true',
          })}
          value={formatCurrency(finalContractFee, { negative: true })}
        />
      </Description.List>

      <Separator color="black" />

      <Description.List>
        <Description.Item className="justify-between">
          <Description.ItemLabel bold className="typo-body1-reading text-black">
            {t('cancel_payment.final_refund_amount')}
          </Description.ItemLabel>
          <Description.ItemValue bold highlight className="typo-headline1">
            {formatCurrency(refundAmount)}
          </Description.ItemValue>
        </Description.Item>

        <ContentBox
          color="purple"
          className="px-3"
          align={
            isRefundAccountButtonVisible || isRefundCardButtonVisible
              ? 'between'
              : 'center'
          }
        >
          {contractStatusDescription}
          {isRefundAccountButtonVisible && <ShowRefundAccountButton />}
          {isRefundCardButtonVisible && <ShowRefundCardButton />}
        </ContentBox>
      </Description.List>
    </div>
  )
}
